import { render, staticRenderFns } from "./BookingsList.vue?vue&type=template&id=cc8f2270&"
import script from "./BookingsList.vue?vue&type=script&lang=js&"
export * from "./BookingsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports